



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyB8HT3L8_xaXDaD_mSppn1puI71ZZzvOMc",
  authDomain: "thehoping-sunexim.firebaseapp.com",
  projectId: "thehoping-sunexim",
  storageBucket: "thehoping-sunexim.firebasestorage.app",
  messagingSenderId: "564139603993",
  appId: "1:564139603993:web:a7474d7f56e5bcb06a9288",
  measurementId: "G-6D5YMS9S59"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



